/** Betting closes this many ms before the round's first kickoff. */
export const ROUND_LOCK_BUFFER_MS = 5 * 60 * 1000;
